import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
// material
import { IconButton, Menu, Button, Stack } from '@mui/material';
import Iconify from '../../components/iconify';
import DeleteReasonPopup from './moreMenuComponent/DeleteReasonPopup'
import ViewHistoryPopup from './moreMenuComponent/ViewHistoryPopup';
import { PATH_Admin, PATH_AllPages, PATH_MasterUser } from '../../routes/paths';
import { handleError, ACCESSABLE_VALUE } from '../../auth/utils';
// ----------------------------------------------------------------------------------------------------------------

MasterMoreMenu.propTypes = {
    rowId: PropTypes.object,
    masterName: PropTypes.string,
    columnData: PropTypes.array,
    rowData: PropTypes.array,
};
// ----------------------------------------------------------------------------------------------------------------

export default function MasterMoreMenu({ rowId, masterName, columnData, rowData }) {

    const ref = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [openModalForDelete, setOpenModalDelete] = useState(false);
    const [openModalForViewHistory, setOpenModalViewHistory] = useState(false);
    const [selectedRow, setSelectedRow] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();
    const path = location.pathname.split('/')[1];

    const loggedInUserDetails = useSelector(state => state.userdetails.userValue);
    const helpTopicPageAccess = loggedInUserDetails?.HelpTopicPageAccess?.[0];
    const hasEditTopicButton = helpTopicPageAccess?.HasEditTopicButton ?? '1';

    const handelClick = () => {
        setIsOpen(true);
    };

    const handelDelete = () => {
        setSelectedRow([rowId.row.id])
        setIsOpen(false);
        setOpenModalDelete(true);
    };

    const handelViewHistory = () => {
        // setIsOpen(false);
        // setOpenModalViewHistory(true);
        const editrow = rowId.row;
        if (path === 'helpadmin') {
            if (masterName === "helptopic") {
                navigate(PATH_Admin.addedithelptopics, { state: { rowData: editrow } });
            }
            else {
                navigate(PATH_Admin.addeditsubcategory, { state: { rowData: editrow } });
            }
        }

        if (path === 'masteruser') {
            if (masterName === "helptopic") {
                navigate(PATH_MasterUser.addedithelptopics, { state: { rowData: editrow } });
            }
            else {
                navigate(PATH_MasterUser.addeditsubcategory, { state: { rowData: editrow } });
            }
        }

        if (path === 'allpages') {
            if (masterName === "helptopic") {
                navigate(PATH_AllPages.addedithelptopics, { state: { rowData: editrow } });
            }
            else {
                navigate(PATH_AllPages.addeditsubcategory, { state: { rowData: editrow } });
            }
        }
    };

    const handleDeleteConfirmation = () => {
        setOpenModalDelete(false);
        window.location.reload();
    };

    const handleViewHistoryConfirmation = () => {
        setOpenModalViewHistory(false);
    };

    const handelhelptopicPreview = () => {
        // setOpenModalDelete(true);
    }

    return (
        <>
            <IconButton ref={ref} onClick={handelClick}>
                <Iconify icon="ic:baseline-more-vert" width='20px' height='20px' />
            </IconButton>

            <Menu
                open={isOpen}
                anchorEl={ref.current}
                onClose={() => setIsOpen(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            >
                {masterName === "helptopic" || masterName === "subcategory" ? (<Stack direction='column' alignItems='center' justifyContent='left' pl={1} pr={3}>
                    <Button size='small'
                        sx={{ color: 'text.primary', '&:hover': { color: 'text.main' } }}
                        disabled={hasEditTopicButton !== ACCESSABLE_VALUE}
                        onClick={handelViewHistory}
                    >
                        Edit
                    </Button>

                    {/* <Button size='small' sx={{ color: 'text.primary', '&:hover': { color: 'text.main' } }} onClick={handelhelptopicPreview} disabled="true">    */}
                    {/*    Preview  */}
                    {/* </Button>    */}
                </Stack>) :
                    (<Stack direction='column' alignItems='center' justifyContent='left' pl={1} pr={3}>
                        <Button size='small' sx={{ color: 'text.primary', '&:hover': { color: 'text.main' } }} onClick={handelViewHistory} disabled="true">
                            Delete
                        </Button>

                    </Stack>)}
            </Menu>

            {openModalForDelete && <DeleteReasonPopup confirm={handleDeleteConfirmation} selectedRow={selectedRow} masterName={masterName} />}

            {openModalForViewHistory && <ViewHistoryPopup confirm={handleViewHistoryConfirmation} masterName={masterName} columnData={columnData} rowData={rowId.row} />}
        </>
    );
}